import { ComponentProps } from "react";
import { createTheme } from "flowbite-react";

const h4Theme = createTheme({
  h4: {
    base: "text-lg sm:text-xl font-semibold",
    colors: {
      base: "text-foreground",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
    },
  },
}).h4;

type H4Props = {
  children: React.ReactNode
  color?: keyof typeof h4Theme.colors
  className?: string
} & ComponentProps<"h4">;

const H4 = ({
  children,
  color = "base",
  className = "",
  ...props
}: H4Props) => {
  return (
    <h4
      className={`${h4Theme.base} ${h4Theme.colors[color]} ${className}`}
      {...props}
    >
      {children}
    </h4>
  );
};

H4.displayName = "H4";

export { H4 };
export type { H4Props };
